import { render } from "./ViewSession.vue?vue&type=template&id=9affb976&scoped=true&ts=true"
import script from "./ViewSession.vue?vue&type=script&lang=ts"
export * from "./ViewSession.vue?vue&type=script&lang=ts"

import "./ViewSession.vue?vue&type=style&index=0&id=9affb976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9affb976"]])

export default __exports__